import { render, staticRenderFns } from "./detail-purchase.vue?vue&type=template&id=81dc6fba&"
import script from "./detail-purchase.vue?vue&type=script&lang=js&"
export * from "./detail-purchase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports